export interface CompositionStatusCounter {
  id?: number;
  status?: string;
  statusList?: Array<CompositionStatusCounter>;
  total?: number;
  pending?: number;
}
